<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Entry Pass</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-info" *ngIf="entryPass.owner_association_id">
      Because this entry pass is owned by an association ({{ entryPass.owner_association_name }}), only association members may be linked to the pass.
      <br><br>
      <ng-container *ngIf="entryPass.owner_association_allow_automatic_entry_pass_use">
        This association allows entry passes to be used by its members on check-in, regardless of whether they are linked here.
      </ng-container>
      <ng-container *ngIf="!entryPass.owner_association_allow_automatic_entry_pass_use">
        This association does not allow entry passes to be used by its members on check-in, so only the customers linked here may use the entry pass when checking in normally. The entry pass may still be used by unlinked members when checking in directly from the Association Profile page.
      </ng-container>
    </div>

    <div class="form-group" *ngIf="orgConfig.getOrganizationConfig().entry_pass_linking_instructions !== ''">
      <p>{{ orgConfig.getOrganizationConfig().entry_pass_linking_instructions }}</p>
    </div>

    <div class="form-group">
      <table class="table table-bordered table-12px">
        <thead>
          <tr>
            <th colspan="99">Linked Customers</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer of entryPass.all_customers">
            <td>{{ customer.first_name }} {{ customer.last_name }}</td>
            <td class="table-12px-button-cell">
              <button class="btn btn-sm btn-danger table-12px-button"
                      (click)="removeCustomer(customer.id)">
                Remove
              </button>
            </td>
          </tr>
          <tr *ngIf="entryPass.all_customers.length === 0">
            <td colspan="99">
              No customers selected.
              <ng-container *ngIf="!entryPass.owner_association_id">
                Please select at least one customer before saving.
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-group">
      <label for="searchCustomersInput">Search Customers to Link</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="customerFilters.search"
             (ngModelChange)="handleCustomerFilterChange()">
      <div class="form-text text-danger">{{ errors.related_customer_id }}</div>
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table class="table table-bordered table-hover"
             *ngIf="(customerFilters.search !== '')">
        <tbody *ngIf="!customerResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingCustomers ? 'Loading...' : 'No results' }}
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="customerResultsPresent()">
          <tr style="cursor:pointer"
              *ngFor="let customer of filteredCustomerResults()"
              (click)="selectRelatedCustomer(customer)">
            <td>
              {{ customer.first_name }} {{ customer.last_name }}
              <span class="text-muted">
                {{ dateStringFromISO8601(customer.birthday )}}
                <span *ngIf="customer.email">- {{ customer.email }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errors.all_customer_ids">
      {{ errors.all_customer_ids }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [class.disabled]="!saveEnabled()"
            [disabled]="!saveEnabled()"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
